import dayjs from 'dayjs';

export const machineryPopup = ({
  status,
  machinery_title,
  employee_name,
  point_time,
  speed,
  statusColor,
}: {
  machinery_title: string;
  employee_name: string;
  point_time: string;
  status: string;
  statusColor: string;
  speed: string;
}) => {
  let title = '';
  let number = '';

  if (machinery_title) {
    const arrTitle = machinery_title.split('/');
    title = arrTitle[0];
    number = arrTitle[1];
  }

  return `<div style="display: flex; justify-content: space-between; padding: 6px">
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.08301 5.41671H10.9163V7.25004H9.08301V5.41671ZM9.08301 9.08337H10.9163V14.5834H9.08301V9.08337ZM9.99967 0.833374C4.93967 0.833374 0.833008 4.94004 0.833008 10C0.833008 15.06 4.93967 19.1667 9.99967 19.1667C15.0597 19.1667 19.1663 15.06 19.1663 10C19.1663 4.94004 15.0597 0.833374 9.99967 0.833374ZM9.99967 17.3334C5.95717 17.3334 2.66634 14.0425 2.66634 10C2.66634 5.95754 5.95717 2.66671 9.99967 2.66671C14.0422 2.66671 17.333 5.95754 17.333 10C17.333 14.0425 14.0422 17.3334 9.99967 17.3334Z"
        fill="#9EB33F"
      />
    </svg>
    <div style="margin-left: 10px">
         <p style="font-size: 16px; "><strong>${title ?? ''}</strong></p>
         <p style="font-size: 16px; margin-top: 4px">
         <strong>${number ?? ''}</strong></p>
      <div style="display: flex; justify-content: space-between; margin-top: 8px; gap: 16px">
        <div style="font-size: 14px">
          <p>${employee_name}</p>
          <p>${dayjs(point_time).utc().format('HH:mm:ss')}</p>
          <p>${dayjs(point_time).utc().format('DD.MM.YYYY')}</p>
          
        </div>
       <div style="display: flex; flex-direction: column;">
        <p style="display: flex; font-size: 14px; color: ${statusColor};">
          ${status}
        </p>
         <p  style="display: flex; font-size: 14px;">
          ${speed}
        </p>
      </div>
      </div>
    </div>
  </div>`;
};
